<div class="card">
  <div class="card-header">
    {{ title | translate }}
    <div class="btn-list">
      <div
        *ngIf="showImageFilter && !docsOnly"
        class="d-inline"
        style="font-size: 0.875rem"
      >
        <input
          [ngModel]="filterImages"
          (ngModelChange)="filterImages = $event; buildFolderTree()"
          type="checkbox"
          id="filterImages"
          name="filterImages"
        />
        <label for="filterImages" class="mx-1 my-0">
          {{ 'files.fileListCard.filterImages' | translate }}
        </label>
      </div>
      <button
        *ngIf="archive"
        [disabled]="loading || !files || (files && !files.length)"
        (click)="filesZip()"
        type="button"
        class="btn btn-outline-secondary btn-sm"
      >
        <i class="fa-regular fa-file-archive fa-fw"></i>
        {{ 'shared.terms.downloadAll' | translate }}
      </button>
      <button
        *ngIf="
          filesOptionsFeature && childLinkedObjects && linkedObjectDefinitions
        "
        type="button"
        class="btn btn-outline-secondary btn-sm ms-2 mr-2"
        (click)="openSettings()"
        [title]="
          'files.fileListCard.documentChildrenSettings.title' | translate
        "
      >
        <i class="fa-regular fa-cog fa-fw"></i>
      </button>
      <div *ngIf="!readonly" class="btn-group">
        <button
          [disabled]="loading"
          (click)="addFiles()"
          type="button"
          class="btn btn-outline-secondary btn-sm"
        >
          <i class="fa-regular fa-plus fa-fw"></i>
          {{ 'shared.terms.add' | translate }}
        </button>
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm dropdown-toggle dropdown-toggle-split"
          id="addMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <span class="sr-only"></span>
        </button>
        <div class="dropdown-menu" aria-labelledby="addMenuButton">
          <button
            [disabled]="loading"
            (click)="addFiles()"
            type="button"
            class="dropdown-item"
          >
            <i class="fa-regular fa-plus fa-fw"></i>
            {{ 'files.fileListCard.addFile' | translate }}
          </button>
          <button
            [disabled]="loading"
            (click)="addFiles(null)"
            type="button"
            class="dropdown-item"
          >
            <i class="fa-regular fa-plus fa-fw"></i>
            {{ 'files.fileListCard.addFolder' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="card-body card-body-table"
    tempFileDragDrop
    [objectId]="objectId"
    [objectType]="objectType"
    [object]="object"
    [isFileDroppedFromPage]="isFileDroppedFromPage"
    [source]="'files'"
    (fileUploaded)="fileUploaded($event)"
  >
    <ng-container
      *ngIf="!loading; then filesHasLoaded; else filesIsLoading"
    ></ng-container>
    <ng-template #filesHasLoaded>
      <ng-container
        *ngIf="
          (files && files.length) || (defaultFolders && defaultFolders.length);
          then filesShow;
          else filesHide
        "
      ></ng-container>

      <ng-template #filesShow>
        <ng-container
          *ngTemplateOutlet="
            fileRowTemplate;
            context: { rootFiles: !this.filterImages }
          "
        ></ng-container>

        <sh-folder-tree-table
          [folderContentTemplate]="fileRowTemplate"
          [folders]="folders"
          [showRoot]="false"
          [idPrefix]="'fileListCardFolder'"
          [projectedColumns]="inbox ? 2 : 3"
          (openPaths)="openPaths = $event"
        ></sh-folder-tree-table>
      </ng-template>

      <ng-template #filesHide>
        <div class="text-center text-muted py-3">
          {{ 'files.fileListCard.notFound' | translate }}
        </div>
      </ng-template>
    </ng-template>
    <ng-template #filesIsLoading>
      <sh-loading-indicator class="d-block text-center"></sh-loading-indicator>
    </ng-template>
  </div>
</div>

<ng-template #fileRowTemplate let-folder let-rootFiles="rootFiles">
  <table>
    <tr *ngFor="let file of getFilesForFolder(folder, rootFiles)">
      <td
        [title]="'shared.terms.preview' | translate"
        (click)="filePreview(file)"
        class="text-truncate"
      >
        <div
          class="cursor-pointer"
          [style.margin-left]="
            'calc(1em * ' +
            (folder?.path ? folder.path.split('/').length - 1 : 0) +
            ' + 1em)'
          "
        >
          <i [ngClass]="fileIcon(file.fileType)" class="fa-regular fa-fw"></i>
          {{ file.description }}
        </div>
      </td>
      <td *ngIf="!inbox" width="1%">
        <i
          *ngIf="file.hasLinkedObjects && !readonly"
          class="fa-solid fa-object-subtract mr-4 cursor-pointer"
          (click)="componentService.openImportLinkedObjectsModal(file, this)"
        ></i>
        <i *ngIf="!file.isPrivate" class="fa-regular fa-lock-open fa-fw"></i>
        <i *ngIf="file.isPrivate" class="fa-regular fa-lock fa-fw"></i>
      </td>
      <td class="btn-list">
        <div class="dropdown p-0">
          <button
            type="button"
            class="btn btn-light dropdown-toggle"
            id="rowMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fa-solid fa-ellipsis-v fa-fw"></i>
          </button>
          <div class="btn dropdown-menu" aria-labelledby="rowMenuButton">
            <button
              *ngIf="!readonly && changePrivacyOption"
              class="dropdown-item"
              (click)="updatePrivacy(file)"
            >
              <i class="fa-regular fa-unlock fa-fw"></i>
              {{ 'files.model.changePrivacy' | translate }}
            </button>
            <button
              [disabled]="loading"
              (click)="addFiles(file.folder)"
              type="button"
              class="dropdown-item"
            >
              <i class="fa-regular fa-plus fa-fw"></i>
              {{ 'files.fileListCard.addFileHere' | translate }}
            </button>
            <button class="dropdown-item" (click)="openChangeFolderModal(file)">
              <i class="fa-regular fa-folder fa-fw"></i>
              {{ 'files.fileListCard.changeFolder' | translate }}
            </button>
            <button class="dropdown-item" (click)="fileDownload(file)">
              <i class="fa-regular fa-download fa-fw"></i>
              {{ 'shared.terms.download' | translate }} ({{
                file.size | fileSize
              }})
            </button>
            <button
              *ngIf="!readonly"
              class="dropdown-item"
              (click)="onDeleteClick(file)"
            >
              <i class="fa-solid fa-trash fa-fw"></i>
              {{ 'shared.terms.delete' | translate }}
            </button>
          </div>
        </div>
      </td>
    </tr>
  </table>
</ng-template>
